module.exports = __webpack_public_path__ + "img/11.2d521ea5.jpg";